export default __webpack_public_path__ + "static/media/craon13.a0e44acc.jpg";